export const MOCK_USER_CONSULT_MODAL_DETAILS = {
  isIncludeAssociatedEnt: false,
  isNoteRequired: true,
  noteText: 'Access items associated with this user are included.',
  isIncludeAsscLabel: '',
  lineItemKind: 'User',
};

export const MOCK_USER_CONSULT_MODAL_CONFIG_MAP = {
  enableReassignUser: '1',
  enableReassignStep2: '1',
  defaultReassignee: '33',
  defaultReassigneeName: 'null null (EORO_Reassign1)',
  enableIndividualCommentsForAccountEntitlementRoles: [
    'YES',
    'NO',
    'NORESPONSE',
    'RE-ASSIGN',
    'REASSIGNSTEP2',
  ],
  enableIndividualCommentsForUsers: [
    'DOES NOT WORK FOR ME',
    'WORKS FOR ME',
    'NORESPONSE',
    'TERMINATED',
    'RE-ASSIGN',
  ],
  showReassignPopup: '1',
  certifierUserKey: '33',
};

export const MOCK_USER_CONSULT_MODAL_USER_LIST = [
  {
    id: 2,
    username: 'systemadmin',
    firstname: 'system',
    lastname: 'admin',
    email: '',
    displayname: '',
    manager: 5,
    value: '2',
    label: 'system admin(systemadmin)',
    isChecked: false,
  },
  {
    id: 4,
    username: 'SaviyntSupportAgent2',
    firstname: 'Saviynt',
    lastname: 'Support',
    email: '',
    displayname: '',
    manager: 9,
    value: '4',
    label: 'Saviynt Support(SaviyntSupportAgent2)',
    isChecked: false,
  },
  {
    id: 5,
    username: 'SaviyntSupportAgent3',
    firstname: '',
    lastname: '',
    email: '',
    displayname: '',
    manager: 65,
    value: '5',
    label: '(SaviyntSupportAgent3)',
    isChecked: false,
  },
  {
    id: 6,
    username: 'EO_Campaign_Owner',
    firstname: 'FN',
    lastname: 'LN',
    email: 'yesaswini.k@saviynt.com',
    displayname: '',
    manager: 7,
    value: '6',
    label: 'FN LN(EO_Campaign_Owner) - yesaswini.k@saviynt.com',
    isChecked: false,
  },
  {
    id: 7,
    username: 'EO_Campaign_Owner_Delegate',
    firstname: '',
    lastname: '',
    email: '',
    displayname: '',
    manager: 65,
    value: '7',
    label: '(EO_Campaign_Owner_Delegate)',
    isChecked: false,
  },
  {
    id: 8,
    username: 'EORO_Certifier1',
    firstname: 'FN',
    lastname: 'LN',
    email: '',
    displayname: '',
    manager: 61,
    value: '8',
    label: 'FN LN(EORO_Certifier1)',
    isChecked: false,
  },
  {
    id: 9,
    username: 'AOMD_Owner',
    firstname: '',
    lastname: '',
    email: '',
    displayname: '',
    manager: 65,
    value: '9',
    label: '(AOMD_Owner)',
    isChecked: false,
  },
  {
    id: 10,
    username: 'AOMD_User1',
    firstname: '',
    lastname: '',
    email: 'geetha.t@saviynt.com',
    displayname: '',
    manager: 95,
    value: '10',
    label: '(AOMD_User1) - geetha.t@saviynt.com',
    isChecked: false,
  },
  {
    id: 11,
    username: 'oo_owner1',
    firstname: '',
    lastname: '',
    email: 'test9@saviynt.com',
    displayname: '',
    manager: 65,
    value: '11',
    label: '(oo_owner1) - test9@saviynt.com',
    isChecked: false,
  },
  {
    id: 12,
    username: 'oo_owner11',
    firstname: '',
    lastname: '',
    email: 'test10@saviynt.com',
    displayname: '',
    manager: 65,
    value: '12',
    label: '(oo_owner11) - test10@saviynt.com',
    isChecked: false,
  },
];
